module.exports = __webpack_public_path__ + "static/media/calendar_sample_templete - Sheet1.f367ed48.csv";